/* eslint-disable @next/next/no-img-element */
import IconTile from '@alltrails/denali/components/IconTile';
import Filter from '@alltrails/denali/icons/Filter';
import Hiking from '@alltrails/denali/icons/Hiking';
import List from '@alltrails/denali/icons/List';
import Map from '@alltrails/denali/icons/Map';
import Place from '@alltrails/denali/icons/Place';
import Park from '@alltrails/denali/icons/PlacePark';
import Record from '@alltrails/denali/icons/Record';
import Shield from '@alltrails/denali/icons/Shield';
import Signpost from '@alltrails/denali/icons/Signpost';
import TrailDog from '@alltrails/denali/icons/TrailDog';
import Waterfall from '@alltrails/denali/icons/Waterfall';
import type { AlgoliaSearchResult } from '@alltrails/types/AlgoliaResults';
import getPOIIcon from '../../utils/getPOIIcon';
import getSizedSponsoredListImageUrl from '../../utils/getSizedSponsoredListImageUrl';
import styles from './styles/styles.module.scss';

export type ResultIconProps = {
  result: AlgoliaSearchResult;
};

const ResultIcon = ({ result }: ResultIconProps) => {
  switch (result.type) {
    case 'area':
      return <IconTile icon={{ Component: result.area_type === 'N' ? Shield : Park }} />;
    case 'filter':
      if (result.filters?.activity?.includes('hiking')) {
        return <IconTile icon={{ Component: Hiking }} />;
      }
      if (result.filters?.suitability?.includes('dogs')) {
        return <IconTile icon={{ Component: TrailDog }} />;
      }
      if (result.filters?.feature?.includes('waterfall')) {
        return <IconTile icon={{ Component: Waterfall }} />;
      }
      return <IconTile icon={{ Component: Filter }} />;
    case 'guide':
      return (
        <div className={styles.imgContainer}>
          <img src={`${result.photo_url}?size=96w96h`} alt="" />
        </div>
      );
    case 'list':
      return <IconTile icon={{ Component: List }} />;
    case 'map':
      return <IconTile icon={{ Component: Map }} />;
    case 'page':
      return (
        <div className={styles.imgContainer}>
          <img src={result.image_url} alt="" />
        </div>
      );
    case 'place':
      return <IconTile icon={{ Component: Place }} />;
    case 'poi':
      return <IconTile icon={{ Component: getPOIIcon(result.subtype) }} />;
    case 'sponsored_list':
      return (
        <div className={styles.imgContainer}>
          <img src={getSizedSponsoredListImageUrl(result.photo_url, 96, 96)} alt="" />
        </div>
      );
    case 'track':
      return <IconTile icon={{ Component: Record }} />;
    case 'trail':
      return <IconTile icon={{ Component: Signpost }} />;
    default:
      return null;
  }
};

export default ResultIcon;
